import { AxiosError } from 'axios';
import { f7, useStore } from 'framework7-react';
import { useState } from 'react';
import { useToast } from './useToast';
import { fetchMAffiliateSettingsApi } from '@/api/infoApi';
import {
  getGmoCardParameterApi,
  getPaymentCard,
  postCreateGmoLinkTypePlusCardEditParameterApi,
} from '@/api/payment';
import { AuthInfoState } from '@/config/initialState';
import { paths } from '@/config/paths';
import { store } from '@/config/store';
import { endpoint } from '@/consts/api';
import { Customer } from '@/types/api/customerApi';
import {
  GmoCardEditParameterResponse,
  GmoCardEditParameterParams,
} from '@/types/api/payment';

export const useGmo = (redirectPage: string) => {
  const { openToast } = useToast();
  const { m_affiliate_id } = useStore(store, 'customerInfo') as Customer; // store.state.customerInfo.m_affiliate_id;
  const { m_customer_id } = useStore(store, 'authInfo') as AuthInfoState; // store.state.authInfo.m_customer_id;
  const authInfo = store.state.authInfo;
  const [GMOCardEditParameters, setGMOCardEditParameters] =
    useState<GmoCardEditParameterResponse>({
      data: {
        success: true,
        error: false,
        data: {
          OrderID: '',
          LinkUrl: '',
          ProcessDate: new Date(),
        },
      },
    });

  const addCreditCardPaymentMethod = async (
    returnUrl: string,
    cancel_url: string,
  ) => {
    if (!m_affiliate_id || !m_customer_id) return;

    try {
      f7.preloader.show();
      const { data: mAffiliateSettings } = await fetchMAffiliateSettingsApi({
        m_affiliate_id,
      });

      if (!mAffiliateSettings.success) {
        throw new Error('エラーが発生しました', {
          cause: 'fetchMAffiliateSettingsApi failed',
        });
      }
      const { gmopg_site_id, gmopg_site_pass, gmopg_shop_id } =
        mAffiliateSettings.data;

      const { data: creditCardPaymentInfo } = await getPaymentCard({
        site_id: gmopg_site_id,
        shop_id: gmopg_shop_id,
        m_customer_id,
        with_trashed: true,
      });
      if (!creditCardPaymentInfo.success)
        throw new Error('エラーが発生しました', {
          cause: 'getPaymentCard Failed',
        });
      const gmoMemberId = `C${m_customer_id}_${
        creditCardPaymentInfo.data.length + 1
      }`;

      const { data: gmoPaymentParams } = await getGmoCardParameterApi({
        memberID: gmoMemberId,
        redirectPage: redirectPage,
        siteID: gmopg_site_id,
        sitePass: gmopg_site_pass,
        shopID: gmopg_shop_id,
      });
      if (!gmoPaymentParams.success) {
        throw new Error('エラーが発生しました', {
          cause: 'getGmoCardParameterApi Failed',
        });
      }

      // GMOからのリダイレクト場所を設定
      const token = authInfo.token;
      const mCustomerId = authInfo.m_customer_id;
      window.localStorage.setItem('token', token);
      window.localStorage.setItem('m_customer_id', mCustomerId.toString());
      window.localStorage.setItem('destination_step', '2');
      window.localStorage.setItem('destination_page', paths.chargePrepaid);

      const createGmoParams: GmoCardEditParameterParams = {
        m_affiliate_id: m_affiliate_id.toString(),
        m_customer_id: m_customer_id.toString(),
        config_id: '1',
        delete_flg: '0',
        complete_url: `${endpoint.BASE_URL}${returnUrl}`,
        cancel_url: `${endpoint.BASE_URL}${cancel_url}`,
      };

      window.localStorage.setItem('fromPage', returnUrl);

      const res = await postCreateGmoLinkTypePlusCardEditParameterApi(
        createGmoParams,
      );
      setGMOCardEditParameters(res);
      return res.data;
    } catch (error: any) {
      openToast((error as AxiosError).message, 'toast-failed');
    } finally {
      f7.preloader.hide();
    }
  };

  return {
    GMOCardEditParameters,
    addCreditCardPaymentMethod,
  };
};
